module.exports = __webpack_public_path__ + "public/images/slider/speaker-1-circle.4a917685113ac6402d53fc3b6d3e166a.webp";